import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { noRoundPercents } from './no-round-percents';

/**
 * Pipe transform accepts
 */
@Pipe({ name: 'iexNoRoundPercents' })
@Injectable()
export class NoRoundPercentsPipe implements PipeTransform {
    transform = noRoundPercents;
}
